import { EmployeeId, UserId } from 'types';

export const EMPLOYEES = (employeeId?: EmployeeId) =>
    `/api/v1/employees${employeeId ? `/${employeeId}` : ''}`;
export const EMPLOYEE_BY_USER_ID = (userId: UserId) => `/api/v1/employees/by-user-id/${userId}`;
